import { ArticleHeading4, Button, TDeviceType } from '@cian/ui-kit';
import React from 'react';
import cn from 'classnames';

import { H2 } from '../H2';
import { Section } from '../Section';
import { DealStepCard } from '../DealStepCard';
import { DealStepsGrid } from '../DealStepsGrid';
import { DealStepCardLast } from '../DealStepCardLast';
import { NBSP } from '../../constants/symbols';

import * as styles from './styles.css';

export const DealStepsSection: React.FC<{
  onChoseRealtorClick(): void;
  onCreateDealClick(): void;
  deviceType: TDeviceType;
}> = ({ deviceType, onChoseRealtorClick, onCreateDealClick }) => {
  const isDesktop = deviceType === 'desktop';

  return (
    <Section testId="dealStepsSection">
      <H2>{`Лёгкий путь к сделке за${NBSP}4${NBSP}шага`}</H2>
      <DealStepsGrid
        deviceType={deviceType}
        steps={[
          <DealStepCard
            key="1"
            imageX1Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/boy_x1.png"
            imageX2Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/boy_x2.png"
            heading={
              isDesktop
                ? '1. Расскажите своему риелтору о Циан.Сделке или подберите риелтора на Циан'
                : '1. Расскажите своему риелтору о Циан.Сделке'
            }
            description="Провести электронную регистрацию через сервис «Циан.Сделка» возможно только с помощью риелтора."
            descriptionAppend={
              <button className={cn(styles['select-realtor-button'], styles[deviceType])} onClick={onChoseRealtorClick}>
                <ArticleHeading4 whiteSpace="nowrap" color="primary_100">
                  Выбрать риелтора на Циан
                </ArticleHeading4>
              </button>
            }
          />,
          <DealStepCard
            key="2"
            imageX1Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/filling_application_x1.png"
            imageX2Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/filling_application_x2.png"
            heading="2. Заполнение заявки"
            description="Ваш риелтор укажет всю информацию о сделке и её участниках, прикрепит документы и отправит второй стороне ссылку на оплату услуги."
          />,
          <DealStepCard
            key="3"
            imageX1Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/signed_document_x1.png"
            imageX2Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/signed_document_x2.png"
            heading="3. Подписание документов"
            description="Поможем с выпуском электронных подписей удалённо или доставим их всем участникам в удобное место в РФ. А ещё организуем видеовстречу с представителем банка для подтверждения личностей участников."
          />,
          <DealStepCardLast
            key="4"
            imageX1Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/key_x1.png"
            imageX2Src="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/key_x2.png"
            heading="4. Регистрация в Росреестре"
            description={
              <ul className={styles['bullets-about-registration']}>
                <li>Мы отправим документы в Росреестр онлайн.</li>
                <li>Оплатим госпошлину: её стоимость уже включена в стоимость услуги.</li>
                <li>Оперативно решим любые возникающие вопросы.</li>
                <li>После успешной регистрации отправим участникам сделки все документы на электронную почту.</li>
                <li>При выборе дополнительной услуги «Сервис безопасных расчетов» произведём взаиморасчёт.</li>
              </ul>
            }
          />,
        ]}
      />
      <Button data-testid="dealStepsCreateDealButton" onClick={onCreateDealClick} size="L" fullWidth>
        Провести сделку
      </Button>
    </Section>
  );
};
